import "intersection-observer"

import { useEffect } from "react"
import type { IntersectionOptions } from "react-intersection-observer"
import { useInView } from "react-intersection-observer"

export type WaypointProps = {
  onEnter: () => void
  intersectionOptions?: IntersectionOptions
}

export const Waypoint: React.FC<WaypointProps> = ({
  onEnter,
  intersectionOptions = { threshold: 0 },
}) => {
  const [ref, inView] = useInView(intersectionOptions)

  useEffect(() => {
    if (!inView) return

    onEnter()
  }, [inView, onEnter])

  return <span ref={ref} />
}
